import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { fontSize } from '../../mixins';
import LatamOptions from './LatamOptions';
import { PinkBigCircle, WhiteBigCircle } from './icons';


const LatamListWrapper = styled.div`
  min-width: 330px;
  margin-top: 100px;
  @media screen and (max-width: 430px) {
    max-width: 370px;
    min-width: unset;
    margin-top: 10px;
  }
`;

const StyledOptionsWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin: 32px 0;
  
  @media screen and (max-width: 430px) {
    margin: 24px 0;
  }
`;

const StyledTitle = styled.div`
  font-weight: 700;
  ${fontSize(24)};
  line-height: 100%;
  letter-spacing: -0.46px;
  color: #ffffff;
  margin-bottom: 14px;
  text-transform: uppercase;
  text-align: center;
`;

const StyledLatamIcon = styled.div`
  width: 15%;
  display: flex;
  justify-content: flex-start;
`;

const StyledDiscountWrapper = styled.div`
  width: 100%;
  height: 20px;
  padding-left: 16px;
  padding-right: 16px;
  background: linear-gradient(93.11deg, #d65c74 48.42%, #eca5b3 100%);
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StyledDiscountTitle = styled.span`
  font-weight: 700;
  ${fontSize(10)};
  line-height: 16px;
  letter-spacing: -0.46px;
  color: #fff;
`;

const StyledDiscountPrice = styled.span`
  font-weight: 700;
  ${fontSize(13)};
  line-height: 16px;
  letter-spacing: -0.46px;
  color: #fff;
`;

const StyledLatamList = styled.ul`
  width: 100%;
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
`;

const StyledLatamLi = styled.li`
  width: 100%;
  position: relative;
  background: linear-gradient(96.24deg, #454545 1.53%, #2f2f2f 98.89%);
  border: ${(props) =>
    props.active ? '1px solid #D65C74' : '1px solid #2f2f2f'};
  border-radius: 8px;
  
  &:not(:last-child) {
    margin-bottom: 8px;
  }
  
  &:nth-child(even) {
    border-top-left-radius: unset;
    border-top-right-radius: unset;
  }

  button {
    width: 100%;
    height: 100%;
    color: #fff;
    display: flex;
    align-items: center;
    background-color: transparent;
    border: none;
    padding: 11px 12px;
    cursor: pointer;

    &:focus {
      outline: none;
    }
  }
`;

const StyledPriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 61%;
`;

const StyledLatamName = styled.span`
  font-weight: 800;
  ${fontSize(16)};
  letter-spacing: -0.460567px;
  line-height: 16px;
  margin-bottom: 8px;
`;

const StyledPriceWrapper = styled.div`
  display: flex;
  align-items: baseline;
`;

const StyledOldPrice = styled.span`
  font-weight: 400;
  ${fontSize(12)};
  line-height: 12px;
  letter-spacing: -0.46px;
  color: #b1b1b1;
  text-decoration: line-through;
  margin-right: 4px;
  color: ${(props) => (props.active ? '#787878;' : '#B1B1B1;')};
`;

const StyledNewPrice = styled.span`
  font-weight: 700;
  ${fontSize(14)};
  line-height: 14px;
  letter-spacing: -0.46px;
  color: ${(props) => (props.active ? '#ECA5B3' : '#ffffff')};
`;

const StyledWeekPriceContainer = styled.div`
  width: 81px;
  height: 44px;
  background: ${(props) =>
    props.active
      ? 'linear-gradient(91.88deg, #ECA5B3 -36.02%, #D65C74 68.23%);'
      : 'none'};
  border: ${(props) => (props.active ? 'none' : '0.5px solid #ffffff')};
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const StyledWeekPrice = styled.span`
  color: '#ffffff';
  letter-spacing: -0.460567px;
  font-weight: 700;
  ${fontSize(16)};
  line-height: 100%;
  margin-bottom: 2px;
`;

const StyledTitleWeek = styled.span`
  color: '#ffffff';
  letter-spacing: -0.460567px;
  font-weight: 400;
  ${fontSize(12)};
  line-height: 100%;
`;


const LatamPlan = ({plan, onPlanClick, currentPlans}) => {
  const {t} = useTranslation();

  const renderLatamOption = (i, index) => (
    <React.Fragment key={i.id}>
      {i.mostPopular && (
        <StyledDiscountWrapper>
          <StyledDiscountTitle>
            {t('most_popular').toUpperCase()}
          </StyledDiscountTitle>
          <StyledDiscountPrice>
            {i.mostPopularDiscount} {t('off').toUpperCase()}
          </StyledDiscountPrice>
        </StyledDiscountWrapper>
      )}
      <StyledLatamLi active={plan === i.id}>
        <button onClick={() => onPlanClick(i.id)} id={`plan-button-${index + 1}`}>
          <StyledLatamIcon>
            {plan === i.id ? PinkBigCircle : WhiteBigCircle}
          </StyledLatamIcon>
          <StyledPriceContainer>
            <StyledLatamName>{i.title} {i.period.toUpperCase()}</StyledLatamName>
            <StyledPriceWrapper>
              <StyledOldPrice active={plan === i.id}>
                {i.prevPrice}
              </StyledOldPrice>
              <StyledNewPrice active={plan === i.id}>{i.price}</StyledNewPrice>
            </StyledPriceWrapper>
          </StyledPriceContainer>
          <StyledWeekPriceContainer active={plan === i.id}>
            <StyledWeekPrice>{i.weeklyPrice}</StyledWeekPrice>
            <StyledTitleWeek>{i.week}</StyledTitleWeek>
          </StyledWeekPriceContainer>
        </button>
      </StyledLatamLi>
    </React.Fragment>
  );

  return (
    <>
      <LatamListWrapper>
        <StyledTitle>{t('unlock_all_features')}</StyledTitle>
        <StyledLatamList>
          {currentPlans.map(renderLatamOption)}
        </StyledLatamList>
        <StyledOptionsWrapper>
          <LatamOptions />
        </StyledOptionsWrapper>
      </LatamListWrapper>
    </>
  )
};


export default LatamPlan;